<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目单位：" prop="pid">
                <span>{{pnames[0]}}</span>
            </el-form-item>
            <el-form-item label="单位工程：" prop="pid" v-if="grade>=3">
                <span>{{pnames[1]}}</span>
            </el-form-item>
            <el-form-item label="分部工程：" prop="pid" v-if="grade>=4">
                <span>{{pnames[2]}}</span>
            </el-form-item>
            <el-form-item label="单位工程：" prop="name" v-if="grade==2">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="分部工程：" prop="name" v-if="grade==3">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="单元工程：" prop="name" v-if="grade==4">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="编号：" prop="code">
                <span>{{model.code}}</span>
            </el-form-item>
            <el-form-item label="简称：" prop="alias">
                <span>{{model.alias}}</span>
            </el-form-item>
            <el-form-item label="施工单位名称：" prop="construction_company" v-if="grade==2">
                <span>{{model.construction_company}}</span>
            </el-form-item>
            <el-form-item label="施工单位简称：" prop="construction_company_ab" v-if="grade==2">
                <span>{{model.construction_company_ab}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="场景类型：" prop="scene_type" v-if="model.grade==3">
                <span>{{ transEnu(model.scene_type, "scene_type") }}</span>
            </el-form-item>
            <el-form-item label="灌浆类型：" prop="grout_type" v-if="model.grade==4">
                <span>{{ transEnu(model.grout_type, "grout_type") }}</span>
            </el-form-item>
            <el-form-item label="添加人：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getProjectDivisionParentNames } from '@/api/org'

export default {
    name: 'projectDivisionInfo',
    mixins: [editutil],
    props: {
        pid: {
            type: Number,
            default() {
                return 0;
            }
        },
        grade: {
            type: Number,
            default() {
                return 2;
            }
        }
    },
    data() {
        return {
            model: {
                code: '',
                name: '',
                alias: '',
                remark: '',
                order_index: '',
                grout_type: '',
                scene_type: '',
                pid: '',
                pname: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/projectdivision/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['grout_type', 'scene_type'],
            pnames: [],
        };
    },
    methods: {
        loadOtherData() {
            getProjectDivisionParentNames(this.pid).then(res=>{
                if(res.code ==1){
                    this.pnames = res.data
                }
            })
        },
    }
};
</script>